/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .service('AccessTokensService', AccessTokensService);

    /**
     * @constructor
     * @ngInject
     */
    function AccessTokensService($log, ApiService, UserService) {

        /* Public API */
        var service = {
            requestActiveTokens: requestActiveTokens,
            createToken: createToken,
            revokeToken: revokeToken
        };

        return service;

        /* Private */


        //helper
        function getUserId() {
            return UserService.getUser()
                .then(function (data) {
                    return data.id;
                });
        }


        function requestActiveTokens() {
            return getUserId()
                .then(function (idUser) {
                    return ApiService.call('/users/' + idUser + '/accesstokens', null, 'GET');
                })
                .then(function (response) {
                    return response.data;
                });
        }


        function createToken(name, expiry) {
            let data = {
                "name": name
            };

            if (expiry) {
                data['expiry'] = expiry;
            }

            const body = JSON.stringify(data);

            return getUserId()
                .then(function (idUser) {
                    return ApiService
                        .call2('/users/' + idUser + '/accesstokens', body, {
                            skipResultChecks: true,
                            method: 'POST',
                        })
                        .then(function (response) {
                            return response.data;
                        });
                });
        }


        function revokeToken(idAccessToken) {
            return getUserId()
                .then(function (idUser) {
                    return ApiService
                        .call('/users/' + idUser + '/accesstokens/' + idAccessToken, null, 'DELETE');
                })
                .then(function (response) {
                    return response.data;
                })
        }

    }
})();
